import React, { useState, useEffect } from "react";
import {
  Card,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Typography, Box } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Button from "@mui/material/Button";
import RadioGroup from "@mui/material/RadioGroup";
import toast from "react-hot-toast";
import TextField from "@mui/material/TextField";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";
import CustomCardWrapper from "../../../common/contentType/CustomCardWrapper";
import {
  extractTextFromHTML,
  LazzyLoading,
} from "../../../common/contentType/contentTypeData";
import { analyticFormSubmission, getForm } from "../../../_api/google-forms";
import { useDispatch, useSelector } from "react-redux";
import { setNextEnabled } from "../../../../redux-features/user/userSlice";
import DesktopQuestions from "./google-form-components/DesktopQuestions";
import MobileQuestions from "./google-form-components/MobileQuestions";


const titleStyle = {
  fontStyle: "normal",
  color: "#242424",
  fontWeight: 700,
  fontSize: { sm: "16px", xs: "12px" },
};

const descStyle = {
  fontStyle: "normal",
};

const sectionStyle = {
  padding: "12px 24px",
  width: "100%",
  backgroundColor: "#5048E5",
  borderRadius: "15px",
};

const qCardStyle = {
  mt: "5px",
  borderRadius: "15px",
  border: "1px solid #D8D7D7",
  padding: "10px 12px",
  display: "flex",
  flexDirection: "column",
};


const inputField = {
  fontFamily: "Poppins",
  // p: "5px 8px",
  mt: 5
};

function GoogleForm({ content, handleNextClick }) {
  const dispatch = useDispatch();
  const formId = content?.allContent?.content;
  const { i18n } = useTranslation();
  const lang = i18n.language || "en";
  const user = useSelector((state) => state?.user?.userData?.user);
  const isNextEnabled = useSelector((state) => state.user?.isNextEnabled);
  const userID = user?.id;
  const organizationId = user?.organizationId;
  const [formData, setFormData] = useState({});
  const [responseData, setResponseData] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [questionsIndex, setQuestionsIndex] = useState(0);
  const [value, setValue] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isShownCorrect, setShowCorrect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [analyticsData, setAnalyticsData] = useState([])
  const [error, setError] = useState(null);
  const lessonIndex = useSelector(state => state.user.lessonIndex)
  const skillIndex = useSelector(state => state.user.skillIndex)
  const lessonName = useSelector(state => state.user.lessonName)
  const skillName = useSelector(state => state.user.skillName)
  const moduleId = useSelector(state => state.user.moduleId)
  const lessonId = useSelector(state => state.user.lessonId)
  const skillId = useSelector(state => state.user.skillId)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleRadioChange = (j, i, free) => {
    var questionId = questions[i].id;
    var optionId = j;
    var freeText = "";
    let option = questions[i]?.options.find(option => option.id == optionId)
    let tempAnalyticsData = {
      question_statement: questions[i]?.questionText,
      answer: free ? j : option?.optionText
    }

    if (free) {
      freeText = j;
      optionId = "";
    }
    var data = {
      questionId,
      freeText,
      optionId: parseInt(optionId),
    };
    let temp = {
      qId: questionId,
      opt: j,
    };
    if (value?.length == 0) {
      setValue([...value, temp]);
      setAnalyticsData([...analyticsData, tempAnalyticsData])
    } else {
      var indexOfVal = value.findIndex((x) => x.qId == questionId);
      if (indexOfVal == -1) {
        setValue([...value, temp]);
        setAnalyticsData([...analyticsData, tempAnalyticsData])
      } else {
        let tempValue = [...value];
        tempValue[indexOfVal].opt = optionId;
        analyticsData[indexOfVal].answer = free ? j : option?.optionText
        setValue(tempValue);
        setAnalyticsData(analyticsData)
      }
    }
    var fakeRData = [...responseData];
    var indexOfResponse = fakeRData.findIndex(
      (x) => x?.questionId == questionId
    );
    let tempResponse = responseData;
    if (indexOfResponse === -1) {
      tempResponse[i] = data;
      setResponseData(tempResponse);
    } else {
      fakeRData[indexOfResponse] = data;
      setResponseData(fakeRData);
    }
  };
  const resultData = () => {
    if (!formData?.questions?.length && !responseData?.length)
      return { perc: "N/A", correctCount: "N/A" };
    if (formData?.multiValueForm) {
      let totalPoints = 0;
      let obtainedPoints = 0;
      formData.questions.map((question, i) => {
        question?.options?.map((opt) => {
          if (opt?.id == responseData[i]?.optionId) {
            obtainedPoints += opt?.optionValue;
          }
        });
      });
      return obtainedPoints;
    }
    const correctAnswers = formData.questions.filter(
      (question, i) =>
        question.options[question.trueValue - 1]?.id ==
        responseData[i]?.optionId
    );
    const textCount = formData.questions.filter(
      (val) => val.isFreeText === true
    ).length;
    const questionLength = responseData.length - textCount;
    const percentage =
      correctAnswers && questionLength
        ? ((correctAnswers.length / questionLength) * 100).toFixed(2)
        : 0;

    return {
      perc: percentage,
      correctCount: correctAnswers.length,
      questionLength,
    };
  };

  useEffect(() => {
    window.parent.postMessage(
      { adminForm: { isSubmitted: false } },
      process.env.NEXT_PUBLIC_APP_CLIENT
    );
  }, []);
  useEffect(() => {
    toast.loading(lang === "es" ? "Cargando..." : "Loading...");
    setIsLoading(true);
    setError(null);
    if (formId) {
      getForm(formId, organizationId).then(
        (rowData) => {
          const data = {
            ...rowData,
            questions: rowData?.questions?.map((question) => {
              // Randomize options only for multivalue forms
              if (rowData?.multiValueForm) {
                // Store the correct option before randomization
                const correctOption = question.options && question.trueValue
                  ? question.options[question.trueValue - 1]
                  : null;

                // Randomize options for multivalue forms
                const randomizedOptions = question?.options?.sort(() => Math.random() - 0.5) || [];

                // Find new index of correct option and update trueValue
                let updatedQuestion = { ...question, options: randomizedOptions };
                if (correctOption) {
                  const newCorrectIndex = randomizedOptions.findIndex(opt => opt.id === correctOption.id);
                  updatedQuestion.trueValue = newCorrectIndex + 1; // +1 because trueValue is 1-indexed
                }

                return updatedQuestion;
              } else {
                // Keep options in their original order for non-multivalue forms
                return {
                  ...question,
                  options: question?.options || []
                };
              }
            }),
          };
          setFormData(data);
          setQuestions(data?.questions || []);
          if (!data?.questions?.length) {
            dispatch(setNextEnabled(false));
          } else {
            dispatch(setNextEnabled(true));
          }
          toast.dismiss();
          setIsLoading(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.dismiss();
          setError(error.response.data);
          setIsLoading(false);
          dispatch(setNextEnabled(false));
        }
      );
    }
  }, [formId, organizationId]);
  function handleResponse() {
    toast.loading(
      lang === "es" ? "Enviando formulario..." : "Submiting form..."
    );
    var submissionData = {
      userId: userID,
      formId: formData.id,
      response: responseData,
    };
    // submitResponse(submissionData).then(
    //   (data2) => {
    //     setIsSubmitted(true);
    //     toast.dismiss();
    //     toast.success(lang === "es" ? "Enviado" : "Submitted");
    //     dispatch(setNextEnabled(false));
    //   },
    //   (error) => {
    //     const resMessage =
    //       (error.response &&
    //         error.response.data &&
    //         error.response.data.message) ||
    //       error.message ||
    //       error.toString();
    //     toast.dismiss();
    //   }
    // );
    let email = localStorage.getItem("userEmail")
    let userDetials = JSON.parse(localStorage.getItem("userDetails"))
    let payload = {
      user_name: userDetials?.name,
      module_id: +moduleId,
      lesson_id: +lessonId,
      skill_id: +skillId,
      user_last_name: userDetials?.lastName,
      school_name: userDetials?.schoolName,
      user_email: email,
      successcoach_name: userDetials?.coach,
      mentor_name: userDetials?.mentor,
      organization_id: user?.organizationId,
      form_name: `${lessonName} | ${skillName}`,
      form_submission: [...analyticsData, { question_statement: "total_score", answer: JSON.stringify(resultData() || '{}') }],
      lesson_index: lessonIndex,
      skill_index: skillIndex,
      language: lang
    }
    setIsSubmitted(true);
    toast.dismiss();
    toast.success(lang === "es" ? "Enviado" : "Submitted");
    dispatch(setNextEnabled(false));
    analyticFormSubmission(payload)

  }

  const incrementIndex = (index) => {
    if (index < questions.length - 1) {
      index = index + 1;
    }
    setQuestionsIndex(index);
  };
  const decrementIndex = (index) => {
    if (index > 0) {
      index = index - 1;
    }
    setQuestionsIndex(index);
  };

  const getFileExtensionName = (file) => {
    let fileName = file;
    let regex = new RegExp("[^.]+$");
    let extension = fileName?.match(regex);
    return extension?.[0];
  };

  const renderAllQuestions = () => {
    let preSection = "";
    let sectionBox = (preS, currentS) => {
      if (preS !== currentS) {
        preSection = currentS;
        return (
          <Box sx={{ ...sectionStyle, mt: 1 }}>
            <Typography sx={{ ...titleStyle, color: "#ffff" }}>
              {currentS}
            </Typography>
          </Box>
        );
      }
      return <></>;
    };
    return (
      <div>
        {questions.map((val, ind) => (
          <>
            {val.isFreeText ? (
              <></>
            ) : (
              <>
                {sectionBox(preSection, val.section)}
                <Box>
                  <div key={ind}>
                    <div>
                      <Box sx={qCardStyle}>
                        <Typography variant="subtitle1" sx={titleStyle}>
                          {questions[ind]?.questionText}
                        </Typography>
                        {questions?.[ind]?.questionImage && (
                          <Box
                            sx={{
                              width: { xs: "100%" },
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: { sm: "row", xs: "column" },
                            }}
                          >
                            {getFileExtensionName(questions?.[ind]?.questionImage) == "mp4" ||
                              getFileExtensionName(questions?.[ind]?.questionImage) === "m4v" ? (
                              <video className="google-video" controls>
                                <source
                                  src={questions?.[ind]?.questionImage}
                                  type="video/mp4"
                                ></source>
                              </video>
                            ) : (
                              <img
                                style={{ borderRadius: "20px", width: "100%" }}
                                src={questions?.[ind]?.questionImage}
                                width="auto"
                                alt=""
                              />
                            )}
                          </Box>
                        )}
                        {questions[ind]?.isFreeText ? (
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Typography variant="subtitle1" sx={titleStyle}>
                              {questions[ind]?.questionText}
                            </Typography>
                            <TextField
                              required
                              variant="outlined"
                              label="Write Your Answer"
                              sx={inputField}
                              value={responseData[ind].freeText}
                              id="filled-multiline-static"
                              multiline
                              fullWidth
                              disabled
                              placeholder={
                                lang === "es"
                                  ? "Escribe tu respuesta"
                                  : "Write Your Answer"
                              }
                              onChange={(e) => { }}
                            />
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              ml: 3,
                            }}
                          >
                            {/* <Typography variant="subtitle1" sx={titleStyle}>
                              {questions[ind]?.questionText}
                            </Typography> */}
                            <RadioGroup
                              aria-label={ind}
                              id={"question " + (ind + 1)}
                              name={"question " + (ind + 1)}
                              value={value[ind]}
                              onChange={(e) => { }}
                              sx={{
                                ...descStyle,
                                padding: "10px",
                                height: "fit-content",
                              }}
                            >
                              {questions[ind]?.options?.map((op, j) => (
                                <div key={j}>
                                  <Box
                                    style={{
                                      display: "flex",
                                      marginLeft: "5px",
                                      padding: "5px 10px",
                                      marginTop: 2,
                                      alignItems: "center",
                                      borderRadius: "10px",
                                      justifyContent: "space-between",
                                      backgroundColor:
                                        questions[ind]?.trueValue - 1 == j
                                          ? "#e6f4ea"
                                          : responseData[ind]?.optionId ==
                                          op.id && "#fce8e5",
                                    }}
                                  >
                                    <Box>
                                      <FormControlLabel
                                        sx={{
                                          "& span": {
                                            fontSize: {
                                              sm: "14px",
                                              xs: "12px",
                                            },
                                          },
                                        }}
                                        value={op.optionText}
                                        control={<Radio />}
                                        label={op.optionText}
                                        checked={
                                          questions[ind]?.trueValue - 1 == j
                                        }
                                      />
                                    </Box>
                                    <Box sx={{ mr: 2 }}>
                                      {questions[ind]?.trueValue - 1 == j ? (
                                        <DoneIcon sx={{ color: "#3ec35c" }} />
                                      ) : (
                                        responseData[ind]?.optionId ==
                                        op.id && (
                                          <ClearIcon
                                            sx={{ color: "#ed3c3c" }}
                                          />
                                        )
                                      )}
                                    </Box>
                                  </Box>
                                </div>
                              ))}
                            </RadioGroup>
                          </Box>
                        )}
                      </Box>
                    </div>
                  </div>
                </Box>
              </>
            )}
          </>
        ))}
        <Box>
          <br></br>
        </Box>
      </div>
    );
  };

  const renderResult = () =>
    formData?.multiValueForm ? (
      <>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            p: { sm: "0 20px", xs: "5px" },
            alignItems: "center",
            backgroundColor: "#F9FAFC",
          }}
        >
          <StyleResultString resultData={resultData} formData={formData} />
        </Box>
      </>
    ) : formData?.analyticsEnabled ? (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h2" color={theme.palette.primary.main}>
            {resultData().questionLength > 0 ? `${resultData().perc}%` : ""}
          </Typography>
          <Typography variant="subTitle1" color="text">
            {lang === "es" ? "Tu resultado" : "Your Result"}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: theme.palette.primary.main,
            color: theme.palette.common.white,
            padding: "10px 15px",
            borderRadius: "12px",
            gap: "5px",
          }}
        >
          <Typography variant="subTitle1">
            {lang === "es" ? "Puntos totales" : "Total Points"}:
          </Typography>
          <Typography fontWeight="bold" variant="subTitle1">
            {resultData().questionLength > 0 ? `${resultData().correctCount}/${resultData().questionLength}` : ""}
          </Typography>
        </Box>
      </Box>
    ) :
      (
        <Box sx={{ height: "220px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography variant="h3" color="initial">
            <span dangerouslySetInnerHTML={{ __html: formData?.name }} style={{ whiteSpace: "pre-wrap" }}></span>
          </Typography>
        </Box>
      )

  const checkFileName = getFileExtensionName(
    questions?.[questionsIndex]?.questionImage
  );
  return (
    <Grid
      container
      display="flex"
      flexDirection="column-reverse"
      justifyContent="center"
      alignItems="center"
      sx={{ background: "#fff" }}
    >
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "calc(100vh - 100px)",
          }}
        >
          <LazzyLoading />
        </Box>
      ) : error?.message ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "calc(100vh - 100px)",
            textAlign: "center",
            p: 3,
          }}
        >
          <Typography variant="h5" color="error">
            {error?.error}
          </Typography>
          <Typography variant="body1" color="initial">
            {error?.message}
          </Typography>
        </Box>
      ) : (
        <Grid item xs={12} sx={{ width: "100%" }}>
          {!isOpen && (
            <CustomCardWrapper height={"70vh"}>
              <Grid
                container
                spacing={2}
                flexDirection={{ xs: "column-reverse", md: "row" }}
                height={{ md: "100%" }}
              >
                <Grid
                  item
                  xs={12}
                  md={7}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Box mx={{ xs: 0, md: 4 }}>
                    <Typography
                      sx={{ whiteSpace: "pre-wrap" }}
                      variant="h2"
                      color="primary"
                    >
                      {extractTextFromHTML(formData?.name)}
                    </Typography>
                    <Typography
                      sx={{ whiteSpace: "pre-wrap" }}
                      variant="body1"
                      color="text"
                    >
                      {extractTextFromHTML(formData?.description)}
                    </Typography>
                    <Box mt={{ xs: "1rem", md: "3rem" }} width={{ md: "60%", xs: "100%" }}>
                      <Button
                        disabled={!isNextEnabled}
                        onClick={() => setIsOpen(true)}
                        variant="contained"
                        fullWidth
                      >
                        {lang === "es" ? "Empezar" : "Get Started"}
                      </Button>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={5}
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box
                    sx={{
                      width: "100%",
                      maxHeight: "50vh",
                      aspectRatio: { md: "2/3", xs: "none" },
                    }}
                  >
                    <img
                      src={formData?.image}
                      alt={""}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        borderRadius: "1.8rem",
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </CustomCardWrapper>
          )}
          {isOpen && (
            <>
              {!isSubmitted ? (
                isMobile ? (
                  <MobileQuestions
                    questions={questions}
                    questionsIndex={questionsIndex}
                    value={value}
                    handleRadioChange={handleRadioChange}
                    analyticsData={analyticsData}
                    lang={lang}
                    theme={theme}
                    handleResponse={handleResponse}
                    decrementIndex={decrementIndex}
                    incrementIndex={incrementIndex}
                    checkFileName={checkFileName}
                    inputField={inputField}
                    descStyle={descStyle}
                  />
                ) : (
                  <DesktopQuestions
                    questions={questions}
                    questionsIndex={questionsIndex}
                    value={value}
                    handleRadioChange={handleRadioChange}
                    analyticsData={analyticsData}
                    lang={lang}
                    theme={theme}
                    isMobile={isMobile}
                    handleResponse={handleResponse}
                    decrementIndex={decrementIndex}
                    incrementIndex={incrementIndex}
                    checkFileName={checkFileName}
                    inputField={inputField}
                    descStyle={descStyle}
                  />
                )) : (
                <Box>
                  <Card
                    sx={{
                      backgroundColor: theme.palette.common.lightGray,
                      borderRadius: "1.8rem",
                      border: { sm: `1px solid ${theme.palette.common.disabled}`, xs: "none" },
                      boxShadow: "none",
                      width: "100%",
                      height: { md: "calc(100vh - 200px)", xs: "95vh" },
                      p: "1.5rem",
                      overflowY: "auto",
                    }}
                  >
                    <Grid container spacing={3}>
                      <Grid
                        item
                        xs={12}
                        md={5}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Box
                          width={{ xs: "90%", sm: "60%", md: "70%", xl: "80%" }}
                        // height="100%"
                        >
                          <img
                            src="/assets/img/goal.png"
                            alt=""
                            style={{ width: "100%", height: "auto" }}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                          {
                            isMobile &&
                            <Button fullWidth variant="contained" sx={{ m: 1, py: 2 }}
                              onClick={handleNextClick}
                            >Move Next</Button>
                          }
                        </Box>
                        <Card
                          sx={{
                            backgroundColor: theme.palette.common.white,
                            borderRadius: "1.3rem",
                            boxShadow: "none",
                            width: "`100%",
                            height: "100%",
                            maxHeight: isMobile ? "80vh" : "62vh",
                            p: "1rem",
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          {formData?.analyticsEnabled && (
                            <Box display="flex" flexDirection="column" gap={1}>
                              <Typography
                                variant="subTitle1"
                                fontWeight="500"
                                color="primary"
                                sx={{ whiteSpace: "pre-wrap" }}
                              >
                                {extractTextFromHTML(formData?.name)}
                              </Typography>

                              <Typography
                                variant="subTitle1"
                                fontWeight="500"
                                color="text"
                                sx={{ whiteSpace: "pre-wrap" }}
                              >
                                {extractTextFromHTML(formData?.description)}
                              </Typography>
                            </Box>
                          )}

                          {isShownCorrect
                            ? renderAllQuestions()
                            : renderResult()}
                        </Card>
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        mt: "1rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        alignItems: "center",
                      }}
                    >
                      {formData?.analyticsEnabled && (
                        <Box>
                          <Button
                            variant="contained"
                            onClick={() => setShowCorrect(!isShownCorrect)}
                          >
                            {isShownCorrect
                              ? lang === "es"
                                ? "Resultado"
                                : "Result"
                              : lang === "es"
                                ? "Respuestas correctas"
                                : "Correct Answers"}
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </Card>
                </Box>
              )}
            </>
          )}
        </Grid>
      )}
    </Grid>
  );
}

export default GoogleForm;

const StyleResultString = ({ formData, resultData }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      {/* {formData?.name?.toLowerCase().includes("personality explorer") ? (
        <Box sx={{ my: 5 }}>
          <Typography variant="h5">{t('assessments.personalityStyle.title')}</Typography>
          {resultData() > 60 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.personalityStyle.dominant.title')}</strong> <br />
              {t('assessments.personalityStyle.dominant.description')}
            </Typography>
          ) : resultData() > 45 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.personalityStyle.influence.title')}</strong> <br />
              {t('assessments.personalityStyle.influence.description')}
            </Typography>
          ) : resultData() > 30 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.personalityStyle.steadiness.title')}</strong> <br />
              {t('assessments.personalityStyle.steadiness.description')}
            </Typography>
          ) : (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.personalityStyle.conscientiousness.title')}</strong> <br />
              {t('assessments.personalityStyle.conscientiousness.description')}
            </Typography>
          )}
        </Box>
      ) : formData?.name?.toLowerCase().includes("financial style") ? (
        <Box sx={{ my: 5, whiteSpace: "pre-wrap" }}>
          <Typography variant="h5">{t('assessments.financialStyle.title')}</Typography>
          {resultData() > 84 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.financialStyle.achiever.title')}</strong> <br />
              {t('assessments.financialStyle.achiever.description')}
            </Typography>
          ) : resultData() > 64 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.financialStyle.balancer.title')}</strong> <br />
              {t('assessments.financialStyle.balancer.description')}
            </Typography>
          ) : resultData() > 44 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.financialStyle.adventurer.title')}</strong> <br />
              {t('assessments.financialStyle.adventurer.description')}
            </Typography>
          ) : (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.financialStyle.planner.title')}</strong> <br />
              {t('assessments.financialStyle.planner.description')}
            </Typography>
          )}
        </Box>
      ) : formData?.name?.toLowerCase().includes("work style") ? (
        <Box sx={{ my: 5 }}>
          <Typography variant="h5">{t('assessments.workStyle.title')}</Typography>
          {resultData() > 25 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workStyle.creativity.title')}</strong> <br />
              {t('assessments.workStyle.creativity.description')}
              {t('assessments.workStyle.creativity.example')}
            </Typography>
          ) : resultData() > 20 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workStyle.independence.title')}</strong> <br />
              {t('assessments.workStyle.independence.description')}
              {t('assessments.workStyle.independence.example')}
            </Typography>
          ) : resultData() > 15 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workStyle.collaboration.title')}</strong> <br />
              {t('assessments.workStyle.collaboration.description')}
              {t('assessments.workStyle.collaboration.example')}
            </Typography>
          ) : resultData() > 10 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workStyle.multitasking.title')}</strong>{" "}
              <br />
              {t('assessments.workStyle.multitasking.description')}
              {t('assessments.workStyle.multitasking.example')}
            </Typography>
          ) : (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workStyle.sequential.title')}</strong> <br />
              {t('assessments.workStyle.sequential.description')}
              {t('assessments.workStyle.sequential.example')}
            </Typography>
          )}
        </Box>
      ) : formData?.name?.toLowerCase().includes("thinking style") ? (
        <Box sx={{ my: 5 }}>
          <Typography variant="h5">{t('assessments.thinkingStyle.title')}</Typography>
          {resultData() > 50 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.thinkingStyle.independent.title')}</strong> <br />
              {t('assessments.thinkingStyle.independent.description')}
              {t('assessments.thinkingStyle.independent.example')}
            </Typography>
          ) : resultData() > 35 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.thinkingStyle.collaborative.title')}</strong> <br />
              {t('assessments.thinkingStyle.collaborative.description')}
              {t('assessments.thinkingStyle.collaborative.example')}
            </Typography>
          ) : resultData() > 20 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.thinkingStyle.creative.title')}</strong> <br />
              {t('assessments.thinkingStyle.creative.description')}
              {t('assessments.thinkingStyle.creative.example')}
            </Typography>
          ) : (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.thinkingStyle.analytical.title')}</strong> <br />
              {t('assessments.thinkingStyle.analytical.description')}
              {t('assessments.thinkingStyle.analytical.example')}
            </Typography>
          )}
        </Box>
      ) : formData?.name?.toLowerCase().includes("learning style") ? (
        <Box sx={{ my: 5 }}>
          <Typography variant="h5">{t('assessments.learningStyle.title')}</Typography>
          {resultData() > 45 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.learningStyle.visual.title')}</strong> <br />
              {t('assessments.learningStyle.visual.description')}
            </Typography>
          ) : resultData() > 39 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.learningStyle.auditory.title')}</strong> <br />
              {t('assessments.learningStyle.auditory.description')}
            </Typography>
          ) : resultData() > 33 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.learningStyle.physical.title')}</strong> <br />
              {t('assessments.learningStyle.physical.description')}
            </Typography>
          ) : resultData() > 27 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.learningStyle.verbal.title')}</strong> <br />
              {t('assessments.learningStyle.verbal.description')}
            </Typography>
          ) : resultData() > 21 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.learningStyle.logical.title')}</strong> <br />
              {t('assessments.learningStyle.logical.description')}
            </Typography>
          ) : resultData() > 15 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.learningStyle.social.title')}</strong> <br />
              {t('assessments.learningStyle.social.description')}
            </Typography>
          ) : (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.learningStyle.solitary.title')}</strong> <br />
              {t('assessments.learningStyle.solitary.description')}
            </Typography>
          )}
        </Box>
      ) : formData?.name?.toLowerCase().includes("work shift assessment") ? (
        <Box sx={{ my: 5 }}>
          <Typography variant="h5">{t('assessments.workShift.title')}</Typography>
          {resultData() > 15 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workShift.morning.title')}</strong> <br />
              {t('assessments.workShift.morning.description')}
            </Typography>
          ) : resultData() > 10 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workShift.day.title')}</strong> <br />
              {t('assessments.workShift.day.description')}
            </Typography>
          ) : resultData() > 5 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workShift.evening.title')}</strong> <br />
              {t('assessments.workShift.evening.description')}
            </Typography>
          ) : (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.workShift.night.title')}</strong> <br />
              {t('assessments.workShift.night.description')}
            </Typography>
          )}
        </Box>
      ) : formData?.name
        ?.toLowerCase()
        .includes("path to life and career readiness") ? (
        <Box sx={{ my: 5 }}>
          <Typography variant="h5">{t('assessments.careerReadiness.title')}</Typography>
          {resultData() > 24 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.careerReadiness.high.title')}</strong> <br />
              {t('assessments.careerReadiness.high.description')}
            </Typography>
          ) : resultData() > 14 ? (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.careerReadiness.moderate.title')}</strong> <br />
              {t('assessments.careerReadiness.moderate.description')}
            </Typography>
          ) : (
            <Typography sx={{ whiteSpace: "pre-wrap" }}>
              <strong>{t('assessments.careerReadiness.low.title')}</strong> <br />
              {t('assessments.careerReadiness.low.description')}
            </Typography>
          )}
        </Box>
      ) : ( */}
      <Box>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          justifyContent: "flex-end",
        }}>
          <h2 style={{
            fontWeight: "normal",
            fontSize: "18px",
            color: "#242424",
          }}>
            {t('assessments.generic.totalPoints')}
          </h2>
          <h4 style={{
            backgroundColor: theme.palette.primary.main,
            padding: "10px 15px",
            color: "#ffffff",
            borderRadius: 10,
          }}>{`${resultData()}`}</h4>
        </div>
        <div style={{
          width: "100%",
          backgroundColor: "#F9FAFC",
          padding: "0px",
        }}>
          <Typography
            sx={{ whiteSpace: "pre-wrap" }}
            variant="body1"
            color="initial"
            dangerouslySetInnerHTML={{ __html: formData?.successDescription || "" }}
          />
        </div>
      </Box>
      {/* )} */}
    </>
  );
};
